// Why saving a room note failed
export enum RoomNoteSaveErrorEnum {
    Validation = 'Validation',      // Too long, or CoreAPI rejected the request (400)
    Unauthorized = 'Unauthorized',  // 401: token missing or expired
    Forbidden = 'Forbidden',        // 403: user lacks the right
    NotFound = 'NotFound',          // The room isn't in this apartment, or CoreAPI updated no rooms
    Failed = 'Failed'               // CoreAPI reported an error, network error or anything else
}
